module.exports = __webpack_public_path__ + "static/media/touch2.1f2300d6.png";